import { render, staticRenderFns } from "./DashboardVerwaltung.vue?vue&type=template&id=361e3e6a&scoped=true"
import script from "./DashboardVerwaltung.vue?vue&type=script&lang=js"
export * from "./DashboardVerwaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e3e6a",
  null
  
)

export default component.exports